module.exports = new __parcel__URL__("52643_v.e45bd2c9.jpg").toString();